import { render, staticRenderFns } from "./Transship.vue?vue&type=template&id=2923c415&scoped=true"
import script from "./Transship.vue?vue&type=script&lang=ts"
export * from "./Transship.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923c415",
  null
  
)

export default component.exports